import { Navigate } from "react-router-dom";
import { LP } from "../pages/lp";
import { SimulatorLP } from "../pages/lp/simulator";
import { LayoutLP } from "../pages/lp/layout";
import { QuestionsLP } from "../pages/lp/questions";
import { DesktopAccess } from "../pages/desktopAccess";
import { HowItWorks } from "../pages/lp/howItWorks";
import { AnimationLayout } from "../layout/animation";
import { ForgetPassword } from "../pages/forgetPassword";
import { EmailSended } from "../pages/forgetPassword/email";
import { RedefinePassword } from "../pages/redefinePassword";
import { FirstAccess } from "../pages/firstAccess";

const DefaultRouters = [
    {
        path: "/",
        element: <LP />
    },
    {
        path: "/pix",
        element: <LP />
    },
    {
        element: <LayoutLP background="#FFFFFF" />,
        children: [
            {
                path: "/simular",
                element: <SimulatorLP />
            },
        ]
    },
    {
        element: <LayoutLP useBullets={false} />,
        children: [
            {
                path: "/enquete",
                element: <QuestionsLP />
            },
        ]
    },
    {
        path: "/acesso-computador",
        element: <DesktopAccess />
    },
    {
        element: <HowItWorks />,
        path: "/comofunciona"
    },
    {
        path: "/*",
        element: <Navigate to={"/"} />
    },
    {
        element: <AnimationLayout withAnimation={false} />,
        children: [
            {
                element: <ForgetPassword />,
                path: "/recuperar-acesso",
            },
            {
                element: <ForgetPassword isClient={false}/>,
                path: "/parceiro/recuperar-acesso",
            },
            {
                path: "/email-enviado",
                element: <EmailSended />
            },
            {
                path: "/parceiro/email-enviado",
                element: <EmailSended />
            }
        ]
    },
    {
        element: <AnimationLayout />,
        children: [
            {
                element: <RedefinePassword />,
                path: "/redefinir-senha",
            },
            {
                element: <FirstAccess />,
                path: "/cliente/primeiro-acesso",
            },
            {
                element: <FirstAccess isClient={false} />,
                path: "/parceiro/primeiro-acesso",
            },
        ]
    },
]

export default DefaultRouters;